import {Fragment} from 'react';

const Button: (props: any) => JSX.Element = (props: any) => {

    const {type, children, onClick} = props;

    const handleClick = () => {
        if(onClick) {
            onClick();
        }
    }

    return (
        <Fragment>
            <button type={type ? type : 'button'} className="text-[14px] lg:text-[22px] uppercase p-3 px-4 bg-pomegranate-950 text-white transition-all hover:bg-pomegranate-900" onClick={() => handleClick()} >
                {children}
            </button>
        </Fragment>
    );
}

export default Button;
